// Utils
import { isSharedWithOthers } from 'SharingApp/ts/utils/sharing-utils';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SharingService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        // Util Methods
        this.isSharedWithOthers = isSharedWithOthers;
    }
    // Sharing AJAX Methods
    getSharedItem(urlParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM_COLLECTION, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    postSharedItem(urlParams, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM_COLLECTION, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    putSharedItem(urlParams, putParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM, urlParams);
        return this.ajaxService.putDataObserveBody(url, putParams);
    }
    deleteSharedItem(urlParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    // URL Shortener AJAX methods
    getShortenedURL(fullURL) {
        const url = this.urlsService.SHARING.URL_SHORTENER;
        const params = { full_url: fullURL };
        return this.ajaxService.postFormEncodedDataObserveBody(url, params);
    }
    // TODO: make into a pipe like isSharedWithOthers
    getSharingTooltipMessage(item) {
        /**
         * Returns the tooltip message to display, e.g. 'Shared (View) with YCharts Staff'.
         * If the client group name is long, the CSS will automatically split it across multiple lines.
         */
        let sharingTooltipMessage = '';
        const { permission } = item.sharing;
        if (permission !== null) {
            sharingTooltipMessage = `<div class='multi-line-tooltip'>Shared (${permission.charAt(0).toUpperCase() + permission.slice(1)}) with ${item.sharing.client_group_name}</div>`;
        }
        return sharingTooltipMessage;
    }
    // Private Sharing AJAX Methods
    changeSharedClientGroup(urlParams, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.CLIENT_GROUP_CHANGE, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    // Public Sharing State AJAX Methods
    changePublicSharingState(itemId, itemType, targetState, publicShareGroupId) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.PUBLIC_SHARING_STATE, { itemId, itemType });
        return this.ajaxService.postFormEncodedDataObserveBody(url, {
            publicSharingState: targetState,
            publicShareGroupId,
        });
    }
    getPublicSharingState(itemId, itemType) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.PUBLIC_SHARING_STATE, { itemId, itemType });
        return this.ajaxService.getDataObserveBody(url);
    }
}
SharingService.ɵfac = function SharingService_Factory(t) { return new (t || SharingService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SharingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharingService, factory: SharingService.ɵfac, providedIn: 'root' });
